import { request, RespError, handleFormatRes } from '../../utils';
import { PROM_SUBC_WX_MSG_V2 } from '../../config/url';
import { promSubcWxMsgV2SubcTimeTransformer } from './utils';
/** 微信订阅状态枚举 */
export var PromSubcWxMsgV2State;
(function (PromSubcWxMsgV2State) {
    /** 0-未订阅 */
    PromSubcWxMsgV2State[PromSubcWxMsgV2State["NOT_SUBSCRIBE"] = 0] = "NOT_SUBSCRIBE";
    /** 1-已订阅 */
    PromSubcWxMsgV2State[PromSubcWxMsgV2State["HAS_SUBSCRIBE"] = 1] = "HAS_SUBSCRIBE";
})(PromSubcWxMsgV2State || (PromSubcWxMsgV2State = {}));
// 需要转成 int 型的 key 数组
const needParseIntKey = ['subcState'];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['subcTime'];
/**
 * 微信订阅消息接口v2
 *
 * 用于：微信服务号订阅时，需要把订阅成功的模板id和订阅渠道作为传参调用
 *
 * 接口地址：`/app/promotion/task/prom_subc_wx_msg_v2.cgi`
 * @param chn_id	订阅渠道	，比如 month_task（狂赏印）
 * @param tpl_ids 订阅的模板id列表，多个模板id用分号隔开
 * @returns
 */
export async function promSubcWxMsgV2({ chnId, tplIds }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            chn_id: chnId,
            tpl_ids: (tplIds || []).join(';'),
        };
        // 接口请求
        const result = await request.get(PROM_SUBC_WX_MSG_V2, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    transformer: promSubcWxMsgV2SubcTimeTransformer
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
